import { StorageService } from '../../../platform/StorageService';

export class IncognitoTracker implements Iterable<[string, string]>{

    private data = {} as Record<string, string>;

    constructor(private store: StorageService, private keyGroup: string) {
        this.readFromStore();
    }

    public get(key: string) {
        return this.data[key] ?? null;
    }

    public set(key: string, value: string) {
        this.data[key] = value;
        this.writeToStore();
    }

    public clear() {
        this.data = {};
        this.writeToStore();
    }

    private readFromStore() {
        this.data = this.store.get(`deqo/boards/${this.keyGroup}/incognitoTracker`) || {};
    }

    private writeToStore() {
        this.store.put(`deqo/boards/${this.keyGroup}/incognitoTracker`, this.data);
    }

    [Symbol.iterator](): Iterator<[string, string], any, undefined> {
        return Object.entries(this.data)[Symbol.iterator]();
    }
}


